<template>
  <div id="app">
    <RetirementCalculator />
  </div>
</template>

<script>
import RetirementCalculator from "./components/RetirmentCalculator.vue";

export default {
  name: "App",
  components: {
    RetirementCalculator,
  },
};
</script>

<style>
#app {
}
</style>
